import {createStore, applyMiddleware} from 'redux';
import reducers from './reducers';
import reduxPromise from 'redux-promise';

export const configureStore = () => {
  const store = createStore(reducers, applyMiddleware(reduxPromise));

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const nextRootReducer = require('./reducers');
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
};
